import styled from "styled-components";

export const HeaderPrimary = styled.div`
    font-size: 3em;
    text-align: center;
    color: #043c4a;
`;
